import { render } from "./DecorationDigitizationCard.vue?vue&type=template&id=9a2e514c&scoped=true"
import script from "./DecorationDigitizationCard.vue?vue&type=script&lang=js"
export * from "./DecorationDigitizationCard.vue?vue&type=script&lang=js"

import "./DecorationDigitizationCard.vue?vue&type=style&index=0&id=9a2e514c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a2e514c"]])

export default __exports__